import React from 'react';
import { GrFormPrevious, GrFormNext } from 'react-icons/gr';

export default function PaginationButtons({ onPreviousClick, onNextClick, isPreviousDisabled, isNextDisabled }) {
    return (
      <div className="mt-4 flex items-center justify-end gap-2 whitespace-nowrap">
  
  <button
    onClick={onPreviousClick}
    disabled={isPreviousDisabled}
    className={`
      inline-flex items-center gap-1
      rounded-lg border px-3 py-2
      text-xs font-semibold
      transition
      ${
        isPreviousDisabled
          ? "cursor-not-allowed border-slate-200 text-slate-400 bg-slate-50"
          : "border-primary-400 text-primary-600 hover:bg-primary-50"
      }
    `}
  >
    <GrFormPrevious size={20} />
    Previous
  </button>

  <button
    onClick={onNextClick}
    disabled={isNextDisabled}
    className={`
      inline-flex items-center gap-1
      rounded-lg border px-3 py-2
      text-xs font-semibold
      transition
      ${
        isNextDisabled
          ? "cursor-not-allowed border-slate-200 text-slate-400 bg-slate-50"
          : "border-primary-400 text-primary-600 hover:bg-primary-50"
      }
    `}
  >
    Next
    <GrFormNext size={20} />
  </button>

</div>


    );
}
